(ns frontend.ui.component.lp-portal.footer.style
  (:require
   [frontend.ui.style.theme.core :as theme]
   [frontend.ui.style.theme.core :refer [color]]))

(defn footer
  []
  ^{:media {{:screen :only :max-width :1080px}
            {:position "relative"
             :width    "100%"}
            {:screen :only :max-width :599px}
            {}}}
  {:flex       "0 0 auto"
   :padding    " 0 16px"
   :background (theme/color [:footer-bgr :secondary :bg])
   :color      (theme/color [:footer-bgr :text])
   :position   "fixed"
   :bottom     "0"
   :left       "0"
   :right      "0"
   :z-index    "2"})

(defn footer-inner
  []
  ^{:media {{:screen :only :max-width :1080px}
            {:flex-direction  "column"
             :justify-content "center"
             :align-items     "center"}
            }}
  {:display         :flex
   :justify-content :space-between
   :max-width       "1400px"
   :width           "100%"
   :font-size       :10px
   :padding         "15px 0px"
   :margin          "0 auto"
   :flex-direction  "row"
   :align-items     "center"})

(defn links
  []
  ^{:media {{:screen :only :max-width :640px}
            {:flex-direction
             :row}}}
  {:display        :flex
   :flex-direction "row"})

(defn link
  []
  ^{:pseudo {:hover       {:color (theme/color [:footer-bgr :text-hover])}
             :first-child {:border-left-color "transparent"}}}
  ^{:media {{:screen :only :max-width :1080px}
            {:border "none"}}}

  {:display           :flex
   :align-items       :center
   :justify-content   :space-between
   :padding           "0 20px"
   :font-size         "10px"
   :text-transform    :uppercase
   :letter-spacing    "1.5px"
   :line-height       1
   :font-weight       :bold
   :color             (theme/color [:footer-bgr :text])
   :position          :relative
   :border-left-width "1px"
   :border-left-style "solid"
   :border-left-color (theme/color [:footer-bgr :separator])}

  )

(defn mobile-right-container
  []
  ^{:media {{:screen :only :max-width :1080px}
            {:position        :initial
             :justify-content "center"
             :align-items     "center"}}}
  {:display        :flex
   :flex-direction :column})

(defn copyright-desktop
  []
  ^{:media {{:screen :only :max-width :1080px}
            {:display :none}}}
  {})

(defn copyright-mobile
  []
  ^{:media {{:screen :only :max-width :1080px}
            {:display     :flex
             :padding-top :16px}
            {:screen :only :max-width :499px}
            {:flex-direction :column}}}
  {:display    :none
   :text-align :end})

(defn copyright
  []
  {:letter-spacing "1.5px"
   :color          (theme/color [:footer-bgr :text])})

(defn copyright-part
  []
  {:white-space :nowrap})

(defn powered-by
  []
  ^{:media {{:screen :only :max-width :1080px}
            {:margin-top "16px"}}}
  {:right          :30px
   :display        :flex
   :align-items    :center
   :gap            "6px"
   :color          (theme/color [:footer-bgr :text])
   :font-size      "10px"
   :padding-bottom :4px})

(defn zapflow-logo
  []
  {:display      :inline-block
   :padding-left "6px"
   :width        "65px"})
